import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './images/aboutus.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1232bb39"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container wow animate__animated animate__fadeInRight",
  "data-wow-duration": "2s"
};
var _hoisted_2 = {
  class: "row"
};
var _hoisted_3 = {
  class: "col-lg-6 textArea"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "关于我们", -1);
});

var _hoisted_5 = /*#__PURE__*/_createTextVNode("了解更多");

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-6 imgArea"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "aboutus"
  })], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_router_link, {
    class: "more",
    to: "/about"
  }, {
    default: _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  })]), _hoisted_6])]);
}